/**
 * 这段是为了兼容老detail无法迁移的模块
 *
 * 这类模块的调用形式为 window.detailRender.registe('模块名', 模块实例, true);
 *
 * 因为有些模块的权限并不在我们这边，所以无法进行迁移，如物流弹窗(运费模板)，所以需要进行mock适配
 *
 * @export
 */
export default function initDetailRenderAdapter() {
  const modules = {};
  if (!window.detailRender) {
    window.detailRender = {
      registe(name, fn) {
        modules[name] = fn;
      },
      loadModule(name, callback) {
        callback(modules[name]);
      },
    };
  }
}
